'use client'

import { usePathname } from 'next/navigation'
import { useLayoutEffect, useState } from 'react'

/**
 * After a full reload, `usePathname()` can disagree with the URL in the address bar
 * (see next-intl useBasePathname / Next.js #73085). Prefer the real location when they
 * differ so nav active states match immediately on refresh.
 */
export function useHeaderPathname(): string {
	const nextPathname = usePathname()
	const [pathname, setPathname] = useState(nextPathname)

	useLayoutEffect(() => {
		const fromWindow = window.location.pathname
		setPathname(fromWindow !== nextPathname ? fromWindow : nextPathname)
	}, [nextPathname])

	return pathname
}
